import { FlexEnd, Separator } from "@opensea/ui-kit"
import type { ReactNode } from "react"
import { useTranslations } from "use-intl"
import { Button } from "../../../components/Button"
import { useConnect } from "../../../polychain/hooks"
import {
  PaymentMethodOptions,
  PaymentMethodOptionsCard,
  PaymentMethodOptionsWallet,
} from "../PaymentMethodOptions"
import type { PaymentMethod } from "../types"
import { useCardCheckout } from "../use-card-checkout"

type Props = {
  cardDisabled: boolean
  paymentMethod: PaymentMethod | undefined
  timeline: ReactNode
  setPaymentMethod: (paymentMethod: PaymentMethod | undefined) => void
  currencySelector: ReactNode
  hidePaymentMethodOptions?: boolean
}

export function WalletPaymentStep({
  cardDisabled,
  paymentMethod,
  timeline,
  setPaymentMethod,
  currencySelector,
  hidePaymentMethodOptions,
}: Props) {
  const t = useTranslations("wallet.WalletPaymentStep")
  const { activeConnector } = useConnect()

  const cardCheckout = useCardCheckout()

  return (
    <>
      {!hidePaymentMethodOptions && (
        <PaymentMethodOptions
          paymentMethod={paymentMethod}
          setPaymentMethod={setPaymentMethod}
        >
          {activeConnector?.id && (
            <PaymentMethodOptionsWallet
              connectorId={activeConnector.id}
              selectedPaymentMethod={paymentMethod}
            />
          )}
          {!cardDisabled && (
            <PaymentMethodOptionsCard selected={paymentMethod === "card"} />
          )}
        </PaymentMethodOptions>
      )}

      {paymentMethod === "card" ? (
        <>
          <FlexEnd>
            <Button onClick={cardCheckout}>{t("payWithCard")}</Button>
          </FlexEnd>
          <Separator className="my-6" />
        </>
      ) : (
        <>
          {currencySelector}
          <Separator className="my-6" />
          {timeline}
        </>
      )}
    </>
  )
}
